export var mapClientPreviewObjectToClient = function (object) {
    return {
        id: object.id,
        contractNumber: object.contractNumber,
        createdAt: object.created_at,
        // russianLegalEntity: object.russianLegalEntity,
    };
};
